import { render, staticRenderFns } from "./megamenu.vue?vue&type=template&id=04c113ca"
import script from "./megamenu.vue?vue&type=script&lang=ts"
export * from "./megamenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports